import { useEffect, useState } from 'preact/hooks';

export const useIsInitialRender = () => {
  const [isSo, setIsSo] = useState(true);

  useEffect(() => {
    setIsSo(false);
  }, []);

  return isSo;
};
